export default {"src":"/_next/static/media/map-pin-sitter-active.ba316af3.svg","height":58,"width":57,"blurWidth":0,"blurHeight":0};